.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  min-width: 0;
}

.headingRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tuna-spacing-1);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
}

/* The buttons may not make the row taller than the heading, so "Spaces" sits level with the aside's headings */
.actions > * {
  margin-block: calc(-1 * var(--tuna-spacing-1));
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

/* Sentence-case ghost button, per the spec; the Button primitive defaults to uppercase. */
.ghost {
  text-transform: none;
  color: var(--tuna-content-secondary);
}

.count {
  font-weight: normal;
  color: var(--tuna-content-secondary);
}

/* Text starts on the rows' icon column: the rows' open target is inset by spacing-1 */
.toggle {
  align-self: flex-start;
  padding-inline: var(--tuna-spacing-1);
}
